import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

/**
 * Converts between NgbDateStruct and ISO date strings.
 * This bridges ng-bootstrap's datepicker with ngrx-forms which stores dates as ISO strings.
 */
@Injectable()
export class ISODateAdapter extends NgbDateAdapter<string> {
  fromModel(value: string | null): NgbDateStruct | null {
    if (!value) return null;
    const date = new Date(value);
    if (isNaN(date.getTime())) return null;
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    };
  }

  toModel(date: NgbDateStruct | null): string | null {
    if (!date) return null;
    return new Date(date.year, date.month - 1, date.day).toISOString();
  }
}
